import React from 'react'
import AnalyzerCategoriesTable from './Table'
import { useSignal } from '@preact/signals-react'
import { ModalSeeker } from '@ui-seeker/core'



export default function AnalyzerCategories({ tableData, evolutionData, xList  }) {

	const isFullScreen = useSignal(false)

	return <>
		<AnalyzerCategoriesTable tableData={tableData} setFullScreen={() => isFullScreen.value = !isFullScreen.value} evolutionData={evolutionData} xList={xList} isFullScreen={isFullScreen.value} />
		<ModalSeeker
			isOpen={isFullScreen.value}
			controller={() => isFullScreen.value = false}
			card={{ sx: { p: 0 } }}
			containerProps={{ fullScreen: true, sx: { '.MuiDialogContent-root': { p: 0 } }}}
			hideActions>
			<AnalyzerCategoriesTable
				tableSx={{
					sx: {
						height: '100%',
						maxHeight: '100%',
					}
				}}
				tableData={tableData}
				setFullScreen={() => isFullScreen.value = !isFullScreen.value}
				evolutionData={evolutionData}
				xList={xList}
				isFullScreen={isFullScreen.value} />
		</ModalSeeker>
	</>
}